import templateUrl from './work-order-manual-claim-preview-modal.component.html';

export const WorkOrderManualClaimPreviewModalComponent = {
    controller: WorkOrderManualClaimPreviewController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
};

function WorkOrderManualClaimPreviewController() {
    const vm = this;

    vm.pageNumber = 1;
    vm.pageSize = 5;
    vm.$onInit = onInit;

    function onInit() {
        vm.workOrderClaim = vm.resolve.workOrderClaim;
        vm.onDismiss = function () {
            vm.dismiss({ $value: 'cancel' });
        };
    }

}
